module.exports = __webpack_public_path__ + "static/Grafika2-62f556849fa87f5acd89eb56a81742b8.png";